import React from 'react';
import Link from 'next/link';
import Image from 'next/image';

const footerLinks = {
  Plataforma: [
    { label: 'Cómo funciona', href: '/#how-it-works' },
    { label: 'Categorías', href: '/#categories' },
    { label: 'Proveedores', href: '/search' },
    { label: 'Inteligencia de demanda', href: '/#demand-intelligence' },
  ],
  'Tu negocio': [
    { label: 'Registra tu comercio o servicio', href: '/sign-up-login' },
    { label: 'Dashboard proveedor', href: '/sign-up-login' },
  ],
  Compradores: [
    { label: 'Buscar con IA', href: '/' },
    { label: 'Solicitar cotización', href: '/sign-up-login' },
    { label: 'Explorar proveedores', href: '/search' },
    { label: 'Dashboard comprador', href: '/sign-up-login' },
  ],
  Empresa: [
    { label: 'Contacto', href: '/contact' },
    { label: 'Centro de Privacidad', href: '/privacy-center' },
  ],
};

export default function Footer() {
  return (
    <footer className="border-t border-white/10" style={{ background: '#0a0a0e' }}>
      {/* Disclaimer notice */}
      <div style={{ borderBottom: '1px solid rgba(255,255,255,0.04)', background: 'rgba(0,245,196,0.02)' }}>
        <div className="max-w-screen-2xl mx-auto px-6 lg:px-8 xl:px-10 2xl:px-16 py-4">
          <p className="text-xs text-white/40 text-center leading-relaxed">
            MoonDepth facilita el descubrimiento y contacto entre empresas. Verifica al proveedor y acuerda directamente las condiciones antes de contratar o pagar.
          </p>
        </div>
      </div>

      <div className="max-w-screen-2xl mx-auto px-6 lg:px-8 xl:px-10 2xl:px-16 py-16">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-6 gap-12">
          {/* Brand */}
          <div className="lg:col-span-2">
            <div className="flex items-center gap-2.5 mb-4">
              <Image
                src="/assets/images/ChatGPT_Image_22_ago_2026__16_39_48-1787434827722.png"
                alt="MOONDEPTH logo"
                width={36}
                height={36}
                className="flex-shrink-0 object-contain"
              />
              <span className="font-semibold text-base tracking-tight text-white">
                MOONDEPTH
              </span>
            </div>
            <p className="text-sm text-white/50 leading-relaxed max-w-xs">
              La red inteligente de abastecimiento empresarial. Describe lo que
              necesitas. Nosotros encontramos quién puede hacerlo.
            </p>
          </div>

          {/* Links */}
          {Object.entries(footerLinks)?.map(([section, links]) => (
            <div key={`footer-section-${section}`}>
              <h4 className="text-xs font-semibold text-white uppercase tracking-widest mb-4">
                {section}
              </h4>
              <ul className="space-y-2.5">
                {links?.map((link) => (
                  <li key={`footer-link-${link?.label}`}>
                    <Link
                      href={link?.href}
                      className="text-sm text-white/50 hover:text-white transition-colors duration-150"
                    >
                      {link?.label}
                    </Link>
                  </li>
                ))}
              </ul>
            </div>
          ))}
        </div>

        <div className="border-t border-white/10 mt-12 pt-8 flex flex-col sm:flex-row items-center justify-between gap-4">
          <p className="text-xs text-white/40">
            © 2026 MOONDEPTH. Todos los derechos reservados.
          </p>
          <div className="flex items-center gap-6 flex-wrap justify-center">
            <Link href="/legal/privacy" className="text-xs text-white/40 hover:text-white transition-colors">
              Privacidad
            </Link>
            <Link href="/legal/terms" className="text-xs text-white/40 hover:text-white transition-colors">
              Términos
            </Link>
            <Link href="/legal/cookies" className="text-xs text-white/40 hover:text-white transition-colors">
              Cookies
            </Link>
            <Link href="/legal/acceptable-use" className="text-xs text-white/40 hover:text-white transition-colors">
              Uso Aceptable
            </Link>
            <Link href="/legal/supplier-publication" className="text-xs text-white/40 hover:text-white transition-colors">
              Publicación Vendedores
            </Link>
            <Link href="/legal/ai" className="text-xs text-white/40 hover:text-white transition-colors">
              Aviso IA
            </Link>
            <Link href="/contact" className="text-xs text-white/40 hover:text-white transition-colors">
              Contacto
            </Link>
          </div>
        </div>
      </div>
    </footer>
  );
}